import Resource from './resource-class'

class OrganizationAPI extends Resource {
  constructor () {
    super()
    this.resource = '/organization'
  }
}

export default new OrganizationAPI()
